export interface IQuestion {
  questionCode: string;
  section: string;
  tab: string;
  locale?: string;
  orderByScore?: string;
  parentCode?: string;
  parentChoice?: string;
  calcByRespondents?: string;
}

export class Question implements IQuestion{
  questionCode = '';
  section = '';
  tab = '';
  orderByScore = '';
  locale = '';

  constructor() {
  }
}
